import { ajax } from '@setel/webcommon/exposes/ajax';
import axios, { AxiosRequestConfig } from 'axios';

export interface IPaginationParam {
  perPage?: number;
  page?: number;
}

export interface IPaginationResult<Result> {
  items: Result[];
  isEmpty: boolean;
  page: number;
  perPage: number;
  pageCount: number;
  total: number;
}

export const fetchPaginatedData = <Result>(
  url: string,
  pagination: IPaginationParam,
  options: AxiosRequestConfig = {}
) =>
  ajax<IPaginationResult<Result>>({
    url,
    ...options,
    params: {
      ...pagination,
      ...options.params,
    },
    select: ({ data, headers }) => {
      const items = data || [];

      return {
        items,
        isEmpty: items.length === 0,
        page: +headers['x-page'] || 0,
        perPage: +headers['x-per-page'] || 0,
        pageCount: +headers['x-pages-count'] || 0,
        total: +headers['x-total-count'] || 0,
      };
    },
  });

export const axiosWithoutRefreshToken = axios;

export const filterEmptyString = (params: object) => {
  const result: any = {};

  Object.entries(params).forEach(([key, value]) => {
    if (value !== '') {
      result[key] = value;
    }
  });

  return result;
};
